import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom';

const portal: HTMLElement = document.createElement('div');
document.body.appendChild(portal);

type DraggableProps = {
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  children: JSX.Element;
};

export const DraggableHOC: <P extends DraggableProps>(props: P) => JSX.Element = (props) => {
  const isDragging = props.snapshot.isDragging;

  if (!isDragging) return props.children;

  return ReactDOM.createPortal(props.children, portal);
};
